import autoComplete from "@tarekraafat/autocomplete.js/dist/autoComplete";
import api from "./ajax";

import { addSendTo, removeSendTo } from "./send-message";
import getInputSelection from "../utils/getInputSelection";


const sendMessageToAutoComplete = () => {
	if (document.getElementById('sendMessageToAutoComplete')) {
		const sendToAutoComplete = new autoComplete({
			selector: "#sendMessageToAutoComplete",
			placeHolder: "Search sub contractors",
			data: {
				src: async (query) => {
					const response = await api.getSubContractorsByName(query, false, this);

					if (!response.error) {
						const {body: subContractors} = response;

						return subContractors
					}

					return [];
				},
				keys: ['detailed_name']
			},
			query: (query) => {
				// Split query into array
				const querySplit = query.split(",");
				// Get last query value index
				const lastQuery = querySplit.length - 1;
				// Trim new query
				const newQuery = querySplit[lastQuery].trim();

				return newQuery;
			},
			events: {
				input: {
					selection(event) {
						const feedback = event.detail;
						const input = sendToAutoComplete.input;
						const {selection: selectionObject} = feedback;

						// Trim selected Value
						const selection = selectionObject.value[selectionObject.key].trim();
						// Split query into array and trim each value
						const query = input.value.split(",").map(item => item.trim());

						// Add the id to send Message to
						addSendTo(selectionObject.value);

						// Remove last query
						query.pop();
						// Add selected value
						query.push(selection);
						// Replace Input value with the new query
						input.value = query.join(", ") + ", ";
					}
				}
			},
		});

		// On delete
		$('#sendMessageToAutoComplete').on('keydown', (e) => {
			const {keyCode, currentTarget} = e;

			if (keyCode === 8 || keyCode === 46) {
				e.preventDefault();

				const keyPressPos = getInputSelection(currentTarget);
				const {start} = keyPressPos;


				// Split query into array and trim each value
				const query = currentTarget.value.replace(/,\s*$/, "").split(",").map(item => item.trim());
				let inputLength = 0;
				let indexToRemove = false;

				for (let i = 0; i < query.length; i++) {
					const stringLength = query[i].length + 2;

					inputLength += stringLength;

					if (start <= inputLength) {
						indexToRemove = i;
						break;
					}
				}

				if (indexToRemove !== false) {
					const removed = query[indexToRemove];

					query.splice(indexToRemove, 1);

					removeSendTo('detailed_name', removed);
				}

				const newVal = query.length > 0 ? query.join(", ") + ", " : query.join(", ");

				// Replace Input value with the new query
				currentTarget.value = newVal;
			}
		});
	}
};

export default sendMessageToAutoComplete;